<template>
  <div v-if="(object && object.type == 'path') || object.type == 'group'">
    <el-card>
      <div class="mt20" style="display:flex; justify-content: space-between; align-items:center">
        <div class="svg_preview_img_container">
          <div
            :class="activeItem == index ? 'active svg_preview_item' : 'svg_preview_item'"
            v-for="(item, index) in colorList"
            :key="item"
            @click="handleSetColor(item, index)"
          >
            <!-- <img
              :style="'filter: drop-shadow(' + item + ' 50px 0) drop-shadow(2px 4px 6px ' + item + ');'"
              :src="object.url"
              alt=""
            /> -->
            <div class="image_con">
              <img
                :style="
                  'background-color:' +
                    item +
                    '; -webkit-mask: url(' +
                    object.url +
                    ') no-repeat center; mask: url(' +
                    object.url +
                    ') no-repeat center;'
                "
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="removeIcon" @click="handleRemove">
          <i style="font-size: 26px" class="el-icon-delete"></i>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import ColorListComponent from '@/components/ColorList.vue';
export default {
  components: {
    ColorListComponent,
  },
  props: ['object'],
  data() {
    return {
      aciveColor: 'rgb(255, 96, 214)',
      svg: '',
      activeItem: 0,
      colorList: [
        'rgb(250, 250, 250)',
        'rgb(255, 255, 0)',
        'rgb(0, 85, 255)',
        'rgb(255, 0, 140)',
        'rgb(0, 255, 100)',
        'rgb(200, 0, 255)',
        'rgb(0, 255, 255)',
        'rgb(255, 0, 0)',
        'rgb(0, 128, 255)',
      ],
    };
  },
  mounted() {
    // this.svg = this.object.toSVG();
    // console.log(this.object);
  },
  watch: {
    object: {
      handler(val) {
        if (!val) return;
        this.activeText = val.text;
        this.activeFontFamily = val.fontFamily;
        // debugger;
        // this.charSpacing = val.charSpacing;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleSetColor(val, index) {
      this.activeItem = index;
      this.aciveColor = val;
      this.$emit('svgColorChange', { val, id: this.object.id });
    },
    handleRemove() {
      this.$emit('handleRemove', this.object.id);
    },
  },
};
</script>

<style lang="less">
.font_load_container {
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}
.removeIcon {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  i {
    color: #999;
  }
}
.removeIcon:hover {
  i {
    color: #333;
  }
}
.borad_con_s {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .item {
    margin-right: 10px;
    width: 50%;
    .el-select {
      width: 100%;
    }
    b {
      display: block;
      margin-bottom: 5px;
    }
  }
}
.svg_preview_img_container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  // .svg_preview_item {
  //   width: 50px;
  //   height: 50px;
  //   border: 2px solid #000;
  //   border-radius: 5px;
  //   margin-right: 10px;
  //   overflow: hidden !important;
  //   background: #333;
  //   cursor: pointer;
  //   margin-bottom: 10px;
  //   img {
  //     display: block;
  //     width: 100%;
  //     filter: drop-shadow(rgb(255, 96, 214) 50px 0);
  //     -webkit-appearance: none;
  //     position: relative;
  //     left: -50px;
  //     border-right: 50px solid transparent;
  //   }
  // }
  .svg_preview_item {
    width: 50px;
    height: 50px;
    border: 2px solid #cccccc;
    border-radius: 5px;
    margin-right: 10px;
    // overflow: hidden !important;
    cursor: pointer;
    margin-bottom: 10px;
    padding: 1px;
    box-sizing: border-box;
    &.active {
      border-color: red;
    }
    .image_con {
      background: #333;
      height: 100%;
      border-radius: 3px;
    }
    img {
      display: inline-block;
      width: 100%;
      height: 100%;
      mask-size: contain;
      -webkit-mask-size: contain;
      // mask-position-y: center;
      -webkit-mask-position-y: center;
      // -webkit-mask-size: 100% 100%;
      // mask-size: 100% 100%;
      // height: 50px;
      // filter: drop-shadow(rgb(255, 96, 214) 50px 0);
      // -webkit-appearance: none;
      // position: relative;
      // left: -50px;
      // border-right: 50px solid transparent;
    }
  }
}
</style>
